import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from '@fluentui/react-components';
import { createContext, useContext, useEffect, useState, } from 'react';
import { connectToTeams } from '#src/teams/teams-host.js';
const TeamsHostContext = createContext(null);
/**
 * Descobre se a aplicação está dentro do Teams antes de renderizar o resto:
 * o tema e o login dependem disso.
 */
export function TeamsHostProvider({ children }) {
    const [host, setHost] = useState(undefined);
    useEffect(() => {
        connectToTeams().then(setHost, () => setHost(null));
    }, []);
    if (host === undefined) {
        return _jsx(Spinner, { label: "Carregando...", style: { marginTop: '30vh' } });
    }
    return (_jsx(TeamsHostContext.Provider, { value: host, children: children }));
}
/** O Teams que hospeda a aplicação, ou `null` no navegador comum. */
export const useTeamsHost = () => useContext(TeamsHostContext);
//# sourceMappingURL=TeamsHostProvider.js.map